import { useSelector } from "react-redux";

export default function useAreKidsAllowed() {
    const { item: event } = useSelector(store => store.event.details);
    
    const { prices, iamnotattending, user: { has_ticket } } = useSelector(state => state.event.friends);
    const allSeatsHaveKidsTypes = prices?.every(p => Object.keys(p).some(t => !!p[t].kids));

    return event?.kids_allowed && allSeatsHaveKidsTypes && (!iamnotattending || has_ticket);
}